import { render, staticRenderFns } from "./importToCreateIOrder.vue?vue&type=template&id=2fa0e5f0&scoped=true&"
import script from "./importToCreateIOrder.vue?vue&type=script&lang=js&"
export * from "./importToCreateIOrder.vue?vue&type=script&lang=js&"
import style0 from "./importToCreateIOrder.vue?vue&type=style&index=0&id=2fa0e5f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa0e5f0",
  null
  
)

component.options.__file = "importToCreateIOrder.vue"
export default component.exports